module.exports = __webpack_public_path__ + "static/img/circuit-board_256.18f2017.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/circuit-board_256.png
// module id = YGMS
// module chunks = 0